const lang = {
  'frontend.global.operation.confirm': 'Confirm',
  'frontend.global.operation.ok': 'OK',
  'frontend.global.operation.save': 'Save',
  'frontend.global.operation.finished': 'Finished',
  'frontend.global.operation.cancel': 'Cancel',
  'frontend.global.operation.signin': 'Log in',
  'frontend.global.operation.signout': 'Logout',
  'frontend.global.operation.more': 'See all Projects',
  'frontend.global.operation.viewalll': 'View all',
  'frontend.global.operation.menuopen': 'Menu',
  'frontend.global.operation.menuclose': 'Close',

  'frontend.global.property.websiteenv': 'Beta',
  'frontend.global.property.websitetitle': 'Bridge Builder',
  'frontend.global.property.username': 'Username',
  'frontend.global.property.password': 'Password',
  'frontend.global.property.or': 'or',
  'frontend.global.property.validate': 'Validating',
  'frontend.global.property.userlogout': 'Logout',
  'frontend.global.property.language_en': 'English',
  'frontend.global.property.language_tw': '中文',
  'frontend.global.property.fontsize': 'Size',
  'frontend.global.property.allwrite': '©{0} Bridge Builder',

  'frontend.global.route.home': 'Home',
  'frontend.global.route.service': 'Service',
  'frontend.global.route.project': 'Project',
  'frontend.global.route.contact': 'Contact',

  'frontend.global.hint.username': 'Enter Username',
  'frontend.global.hint.password': 'Enter Password',

  'frontend.global.error.0000': 'Oops !',

  'frontend.local.home.title': 'Bridge Builder:\nBridging ideas, people, and culture.',

  'frontend.local.service.title': `Exhibition creator\nevent organizer and agent`,

  'frontend.local.contact.vatnumber': 'VAT Number',

  'frontend.local.projects.title': 'Project',
  'frontend.local.projects.time': 'Date',
  'frontend.local.projects.location': 'Location',
  'frontend.local.projects.curator': 'Curator',

  'frontend.local.contact.title': `Let's work together`
};

export default lang;
